import { render, staticRenderFns } from "./OrderArticles.vue?vue&type=template&id=12fa5ac9&scoped=true"
import script from "./OrderArticles.vue?vue&type=script&lang=js"
export * from "./OrderArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa5ac9",
  null
  
)

export default component.exports